import type { SbBlokData } from "@storyblok/react";
import { useRouter } from "next/router";

import type { ISiteSettingsBlok } from "@/bloks/SiteSettings/SiteSettings";
import useStore from "@/lib/stateManagement/store";
import useStaticStory from "@/lib/storyblok/useStaticStory";

import UI from "./UI";

export interface AnnouncementBarProps {
  previewData?: {
    [key: string]: SbBlokData;
  };
}

const AnnouncementBar = ({ previewData }: AnnouncementBarProps) => {
  const preview = useStore((state) => state.preview);
  const { locale } = useRouter();

  const { blok } = useStaticStory({
    slug: "site-settings",
    preview,
    folder: "statics",
    previewData,
    locale,
  });

  const settings = blok as ISiteSettingsBlok | undefined;

  return (
    <UI
      announcement={settings?.announcement}
      backgroundColor={settings?.announcementBackgroundColor?.trim()}
      textColor={settings?.announcementTextColor}
    />
  );
};

export default AnnouncementBar;
